import request from '@/utils/request'

//认证登录
export function authenticateLogin(data) {
  return request({
    url: '/authenticate/AuthenticateLogin',
    method: 'post',
    data: data
  })
}

//获取用户计数器
export function getUsersCounter(data) {
  return request({
    url: '/userAccess/counter',
    method: 'get',
    data: data,
    enableLoading: false
  })
}